var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8066 19.0614L11.9275 7.97836M18.8066 11.841C16.8375 14.072 13.9564 15.4792 10.7466 15.4792C7.53691 15.4792 4.65583 14.072 2.68665 11.841M2.68665 19.0614L9.56578 7.97836M10.7466 3.83696C9.51014 3.83696 8.50776 4.83935 8.50776 6.07585C8.50776 6.87894 8.93059 7.58327 9.56578 7.97836M10.7466 3.83696C11.9831 3.83696 12.9855 4.83935 12.9855 6.07585C12.9855 6.87894 12.5627 7.58327 11.9275 7.97836M10.7466 3.83696V2.94141M11.9275 7.97836C11.5847 8.19158 11.1801 8.31474 10.7466 8.31474C10.3132 8.31474 9.90858 8.19158 9.56578 7.97836",
    stroke: "#182B43",
    strokeWidth: 1.79111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassIcon);
export default __webpack_public_path__ + "static/media/compassIcon.a60c13310296e0f27d4cc6980542a1e6.svg";
export { ForwardRef as ReactComponent };